import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { initializeApp } from "firebase/app";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const firebaseConfig = {
  apiKey: window.__env.FIREBASE_API_KEY,
  authDomain: window.__env.FIREBASE_AUTH_DOMAIN,
  projectId: window.__env.FIREBASE_PROJECT_ID,
  storageBucket: window.__env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: window.__env.FIREBASE_MESSAGING_SENDER_ID,
  appId: window.__env.FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
